import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { useSelector } from 'react-redux';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { Link } from 'react-router';
import { routes } from '@/utils/routes/routes';
import Spinner from './Components/spinner';
import NoProducts from './Components/noProduct';

const Pricing = () => {
  const [loading, setLoading] = useState(true);
  const [priceList, setPriceList] = useState<any | null>([]);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const currencyCode = useSelector(
    (state: RootState) => state.common.header?.currency?.symbol
  );

  const handleCategoryClick = (categoryName: string) => {
    setActiveCategory(categoryName);
  };

  const getPricingList = async () => {
    try {
      const response = await getData(
        `get_all_products?warehouse_id=0&type=service`
      );

      if (response.status === 200 || response.status === 201) {
        if (response?.data?.data?.length > 0) {
          setPriceList(response.data.data);
          setActiveCategory(response.data.data[0].name);
        }
      } else {
        throw new Error('Failed to fetch products');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPricingList();
  }, []);

  const activeProducts =
    priceList?.find((cat) => cat.name === activeCategory)?.product || [];

    console.log("activeProducts123",activeProducts)
  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-section mb-3">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1 className="page-title">Pricing</h1>
                  <ul>
                    <li>
                      <Link to={routes.home}>Dashboard</Link>
                    </li>
                    <li className="active"> Pricing</li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
          <section className="price-section mt-4" id="pricing">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <Swiper
                    spaceBetween={15}
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 7,
                      },
                    }}
                    className='category-swiper'
                  >
                    {priceList?.map((category: any, catindex: any) => (
                      <SwiperSlide key={`${category.name}-${catindex}`}>
                        <div
                          className={`category-container ${
                            activeCategory == category.name
                              ? 'active-swiper'
                              : ''
                          }`}
                        >
                          <a
                            role="button"
                            className="category-button-new"
                            onClick={() =>
                              handleCategoryClick(category.name)
                            }
                          >
                            <div className="order_list">
                              <div className="prod-img-dv">
                                <img
                                  src={category.image_path}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <div className="prod-slider-name">
                                <p>{category.name}</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>                  
                  <div className="prodcat-list">
                    {activeProducts.length > 0 ? (
                      <div className="row">
                          {activeProducts.map((item, index) => (
                            <div key={`${item.id}-${index}`} className='col-md-6'>
                              <div className="search-page-product-list-card">
                                <div className="search-page-product-img">
                                  <img
                                    src={item.image_path}
                                    alt={item.name}
                                  />
                                </div>
                                <div className="search-page-prod-info-grid">
                                  <div className="search-page-prod-info align-items-center">
                                    <div className="search-page-prod-info-s">
                                      <h5 className='search-product-name'>{item.name}</h5>
                                    </div>
                                    <div className="search-page-prod-info-hr"></div>
                                    <div className="search-page-prod-info-e">
                                      <div className="search-page-prod-price">
                                        <span className='cur-symbol'>{currencyCode}</span>{parseFloat(item.price).toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ) : (
                      <NoProducts />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Pricing;
